function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useMemo } from 'react';
import { classnames, guid } from '@bydesign-ui/utils';
import { useCombineCallback, useToggle } from '@bydesign-ui/hooks';
import { usePrefixCls } from '@byte-design/config';
import { useCreateCascader } from '../../hooks/tree';
import { RcPopper } from '../../hooks/popper';
import { RcPopover } from '../../units/popover-wrapper';
import { SelectInput } from '../select/components/SelectInput';
import { TreePopper } from './components/TreePopper';
import { Down, Up } from './../../common/icons';
export function TreeSelect(props) {
  var className = props.className,
      popoverClassName = props.popoverClassName,
      style = props.style,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$searchable = props.searchable,
      searchable = _props$searchable === void 0 ? false : _props$searchable,
      searchPlaceholder = props.searchPlaceholder,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? true : _props$clearable,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$accordion = props.accordion,
      accordion = _props$accordion === void 0 ? false : _props$accordion,
      _props$selectToExpand = props.selectToExpand,
      selectToExpand = _props$selectToExpand === void 0 ? false : _props$selectToExpand,
      _props$showLine = props.showLine,
      showLine = _props$showLine === void 0 ? false : _props$showLine,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      _props$partialCheckAb = props.partialCheckAble,
      partialCheckAble = _props$partialCheckAb === void 0 ? true : _props$partialCheckAb,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      onSelect = props.onSelect,
      onValueChange = props.onValueChange,
      selectedId = props.selectedId,
      placeholder = props.placeholder,
      renderItem = props.renderItem,
      datasource = props.datasource,
      onExpand = props.onExpand,
      expandedIds = props.expandedIds,
      defaultExpandedIds = props.defaultExpandedIds,
      _props$autoFocusSearc = props.autoFocusSearch,
      autoFocusSearch = _props$autoFocusSearc === void 0 ? false : _props$autoFocusSearc,
      load = props.load,
      filterTreeNode = props.filterTreeNode,
      autoClearSearchValue = props.autoClearSearchValue;
  var changeCombine = useCombineCallback(onSelect, onValueChange);

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 3),
      show = _useToggle2[0],
      handleShow = _useToggle2[1],
      handleHide = _useToggle2[2];

  var handleSelect = useCallback(function (ids, value) {
    handleHide();
    changeCombine(ids[0], value);
  }, [changeCombine, handleHide]);

  var _useCreateCascader = useCreateCascader({
    value: selectedId === undefined ? [] : [selectedId],
    multiple: false,
    spread: false,
    partialCheckAble: partialCheckAble,
    onChange: handleSelect,
    accordion: accordion,
    selectToExpand: selectToExpand,
    datasource: datasource,
    onExpand: onExpand,
    expandedIds: expandedIds,
    defaultExpandedIds: defaultExpandedIds,
    load: load
  }),
      cascader = _useCreateCascader.cascader;

  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var handleClear = useCallback(function (val) {
    if (!val) {
      cascader.resetValue();
    }
  }, []);
  var displayInfo = cascader.getDisplayInfo().map(function (item) {
    var id = item.id,
        label = item.label,
        disabled = item.disabled,
        readonly = item.readonly;
    return {
      label: label,
      value: id,
      disabled: disabled,
      readonly: readonly
    };
  });
  var cls = classnames(usePrefixCls('tree-select', {
    warning: invalid,
    focus: show
  }), className);
  return React.createElement("div", {
    className: cls,
    style: style
  }, React.createElement(RcPopper, null, React.createElement(SelectInput, {
    clearable: !disabled && clearable,
    suffix: show ? React.createElement(Up, null) : React.createElement(Down, null),
    value: displayInfo.length && displayInfo[0].label || '',
    placeholder: placeholder,
    size: size,
    disabled: disabled,
    htmlReadOnly: true,
    onValueChange: handleClear,
    triggerId: triggerId
  }), React.createElement(RcPopover, {
    show: show,
    getPopper: function getPopper() {
      return React.createElement(TreePopper, {
        triggerId: triggerId,
        cascader: cascader,
        renderItem: renderItem,
        searchable: searchable,
        searchPlaceholder: searchPlaceholder,
        filterTreeNode: filterTreeNode,
        multiple: false,
        showLine: showLine,
        disabled: disabled,
        show: show,
        autoFocusSearch: autoFocusSearch,
        autoClearSearchValue: autoClearSearchValue
      });
    },
    popoverClassName: popoverClassName,
    offset: {
      x: 0,
      y: 4
    },
    arrow: false,
    placement: placement,
    triggerIds: triggerIds,
    onShow: handleShow,
    onHide: handleHide,
    scaleAnimation: "y"
  })));
}